<template>
  <div id="app">
    <h2>downlink</h2>
    <canble-chart :set="$root.downlink" />
    <h2>rtt</h2>
    <canble-chart :set="$root.rtt" />
  </div>
</template>

<script>
import CanbleChart from './components/chart'

export default {
  name: 'App',
  components: {
    CanbleChart
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/App.vue